<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 14:21:15
 * @LastEditTime: 2020-04-30 14:27:08
 * @Description: 版权声明
 -->
<template>
  <div class="copyright">
    <p>Chrome,Firefox are recommended. Copyright 2020 Sony China. All rights reserved.</p>
    <p>您浏览本网站将被监控。请点击
      <span class="detail" @click="setStatementShowState({ show: !statementShowState })">此处</span>
      获得详细信息。
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Copyright',
  computed: {
    ...mapGetters({
      statementShowState: 'footStore/statementShowState',
    }),
  },
  methods: {
    ...mapActions({
      setStatementShowState: 'footStore/invokeSetStatementShowState',
    }),
  },
};
</script>

<style lang="less" scoped>
.copyright {
  .detail {
    font-size: 14px;
    color: red;
    cursor: pointer;
  }
}
</style>
